import script from "./EditDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./EditDetailsPage.vue?vue&type=style&index=0&id=0cb2811d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb2811d"]])

export default __exports__